import Modal from 'bootstrap/js/dist/modal';


/**
 *
 */
const showModal = (
	containerId: string,
	title: string       = '',
	bodyHTML: string,
	scrollable: boolean = false ) =>
{
	let container = document.querySelector( `#${containerId}` );

	if (!container) {

		container = document.createElement( 'div' );

		container.id = containerId;
		container.classList.add( 'modal', 'fade' );
		container.setAttribute( 'tabindex', '-1' );

		document.body.append( container );
	}

	container.innerHTML = `
		<div class="modal-dialog modal-xl modal-dialog-centered ${scrollable ? 'modal-dialog-scrollable' : ''}">
			<div class="modal-content">
				<div class="modal-header">
					${title ? `<h1>${title}</h1>` : ''}
					<button class="btn btn-link close-button" type="button" data-bs-dismiss="modal" aria-label="Close">
						<i class="fa-solid fa-xmark"></i>
					</button>
				</div>
				<div class="modal-body">
					${bodyHTML}
				</div>
			</div>
		</div>
	`;

	const modal = new Modal( container );

	modal.show();

	container.addEventListener( 'hidden.bs.modal', () => container.remove() );
};


/**
 *
 */
export {showModal};
